import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { ReportService } from "../services/report.service";
import { FileService } from "../../shared/services/file.service";
import { Dealer } from '../../shared/models/dealer.interface';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AbstractReportComponent } from '../abstract.report.component';
import { DeviceDetectorService } from 'ngx-device-detector';
import { CustomerMetric, CustomerMetricResult } from '../models/customer.metric.interface';
import { AdminService } from '../../admin/services/admin.service';
import { MonthType } from '../../shared/models/month.type.interface';
import { NgForm } from '@angular/forms';

export interface CustomerMetricParameterData {
  customerMetric: CustomerMetric;

  dealers: Dealer[];
  years: number[];
  months: MonthType[];
}

@Component({
  selector: 'app-customer-metric',
  templateUrl: './customer-metric.component.html',
  styleUrls: ['./customer-metric.component.scss']
})
export class CustomerMetricComponent extends AbstractReportComponent implements OnInit {

  report: CustomerMetricResult = null;
  parameters: CustomerMetric = {
    dealer_ID: null,
    statusType: null,
    year: (new Date()).getFullYear(),
    startMonth: 0,
    endMonth: 11
  } as CustomerMetric;

  dealer: Dealer;
  quoteStatus: string;

  dealers: Dealer[];
  quoteStatuses: Record<string, string> = {};

  isRequesting: boolean = false;

  constructor(@Inject(LOCALE_ID) locale: string,
    deviceDetectorService: DeviceDetectorService,
    dialog: MatDialog, private reportService: ReportService, private adminService: AdminService,
    private fileService: FileService) {
    super(locale, dialog, deviceDetectorService);
  }

  ngOnInit() {
    this.adminService.getDealers()
      .subscribe({
        next: (data) => {
          this.dealers = data;
          this.showParameters();
        },
        error: (error: string) => this.onError(error)
      });

    this.quoteStatuses['A'] = 'Active';
    this.quoteStatuses['E'] = 'Expired';
    this.quoteStatuses['L'] = 'Lost';
    this.quoteStatuses['W'] = 'Won';

    this.setupDates();
  }

  renderReport() {

    this.getReportFormat()
      .subscribe(formatData => {
        if (formatData == null) return;

        this.isRequesting = true;

        this.reportService.getCustomerMetricExport(this.parameters, formatData.format)
          .subscribe({
            next: (data) => {
              this.isRequesting = false;
              this.fileService.downloadFile(data, 'CustomerMetric' + formatData.extension);
            }
          });
      });
  }

  showParameters() {
    // wait until dropdowns loaded
    if (this.dealers == null)
      return;

    const dialogRef = this.dialog.open(CustomerMetricParameterDialog, {
      width: '550px',
      data: {
        customerMetric: (<any>Object).assign({}, this.parameters),

        dealers: this.dealers,
        years: this.years,
        months: this.months
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
      if (result) {
        this.parameters = result.customerMetric as CustomerMetric;
        this.reportService.setupParameters(this.parameters);

        this.dealer = this.dealers.find(s => s.dealer_ID == this.parameters.dealer_ID);
        this.quoteStatus = this.parameters.statusType == null ? null : this.quoteStatuses[this.parameters.statusType];

        this.isRequesting = true;
        this.reportService.getCustomerMetricReport(this.parameters)
          .subscribe({
            next: (data) => {
              this.isRequesting = false;
              this.report = data;
            },
            error: (error: string) => this.onError(error)
          });
      }
    });
  }

  loadReport() {
    this.report = null;
    if (this.parameters.year == null) return;

    this.isRequesting = true;
    
    this.reportService.getCustomerMetricReport(this.parameters)
      .subscribe({
        next: (data) => {
          this.report = data;
          this.isRequesting = false;
        }
      });
  }
}

@Component({
  selector: 'customer-metric.parameter.dialog',
  templateUrl: 'customer-metric.parameter.dialog.html',
})
export class CustomerMetricParameterDialog {

  constructor(
    public dialogRef: MatDialogRef<CustomerMetricParameterDialog>,
    @Inject(MAT_DIALOG_DATA) public data: CustomerMetricParameterData) { }

  runReport(form: NgForm): void {
    if (form.valid) {
      this.dialogRef.close(this.data);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
